import apiClient from '../utils/apiClient';

// Customer notes — operator-authored free-text log per customer. Pairs
// with backend/routers/customer_notes.py. All endpoints are facility +
// customer scoped server-side; the client doesn't need to filter further.
const base = (facilityId, customerId) =>
  `/api/facilities/${facilityId}/customers/${customerId}/notes`;

const customerNotesService = {
  list: (facilityId, customerId) =>
    apiClient.get(`${base(facilityId, customerId)}/`),
  create: (facilityId, customerId, data) =>
    apiClient.post(`${base(facilityId, customerId)}/`, data),
  update: (facilityId, customerId, noteId, data) =>
    apiClient.patch(`${base(facilityId, customerId)}/${noteId}`, data),
  remove: (facilityId, customerId, noteId) =>
    apiClient.delete(`${base(facilityId, customerId)}/${noteId}`),
};

export default customerNotesService;
